const staticFileBasePath = '/assets/static'

const appConfig: { [key: string]: string } = {
  STUNNR_CLIENT_ID: 'C031614BAB7547B5860C157C7205729A',
  CLIENT_APP: '3',
  APP_LOGO: `${staticFileBasePath}/images/app-logo.svg`,
  PROFILE_SELECTION_ILLUSTRATION_LIGHT: `${staticFileBasePath}/images/select-profile-light.svg`,
  NOT_FOUND_DARK: `${staticFileBasePath}/images/not-found-dark.svg`,
  NOT_FOUND_LIGHT: `${staticFileBasePath}/images/not-found-light.svg`
};

export default appConfig;
